import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "file"];

  validateForm(event) {
    // フォームのバリデーションを実行
    const errors = [];

    // ファイルのバリデーション
    const fileErrors = this.validateFile();
    if (fileErrors.length > 0) {
      errors.push(...fileErrors);
    }

    // エラーがある場合は処理を中断
    if (errors.length > 0) {
      event.preventDefault();
      this.updateMessages(errors);
      window.scrollTo(0, 0);
      return false;
    }

    return true;
  }

  validateFile() {
    const errors = [];
    const fileInput = this.fileTarget;

    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      return errors;
    }

    const file = fileInput.files[0];

    // ファイルタイプのチェック
    const validTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel.sheet.macroenabled.12",
    ];

    if (!validTypes.includes(file.type)) {
      errors.push("添付ファイルが添付可能な拡張子ではありません。");
    }

    // ファイルサイズのチェック（最大10MB）
    if (file.size > 10 * 1024 * 1024) {
      // 10MB
      errors.push("添付ファイルのファイルサイズの上限は10MBです。");
    }

    return errors;
  }

  updateMessages(errors) {
    const messagesContainer = document.querySelector("#flash-messages");
    if (!messagesContainer) return;

    // エラーメッセージの表示
    const alertDiv = document.createElement("div");
    alertDiv.className = "alert alert-danger";
    alertDiv.setAttribute("role", "alert");

    const errorList = document.createElement("ul");
    errorList.className = "list-unstyled mb-0";
    errors.forEach((error) => {
      const li = document.createElement("li");
      li.textContent = error;
      errorList.appendChild(li);
    });

    alertDiv.appendChild(errorList);
    messagesContainer.innerHTML = "";
    messagesContainer.appendChild(alertDiv);
  }
}
